import { FormItem } from '../../../../../../commons/Form/Form.types';
import { ConfirmationBisRowSchema } from './ConfirmationBisRow.types';

export const confirmationBisData: FormItem<ConfirmationBisRowSchema>[][] = [
  // [
  //   {
  //     name: 'domain',
  //     placeholder: "Catégories d'activité...",
  //     label: "Catégories d'activité",
  //     type: 'select',
  //     id: 'categories',
  //     required: true,
  //     options: [
  //       {
  //         value: '1',
  //         label: 'Travaux de bâtiment',
  //       },
  //       {
  //         value: '2',
  //         label: 'Travaux Publics',
  //       },
  //       {
  //         value: '3',
  //         label: 'Fournitures',
  //       },
  //       {
  //         value: '4',
  //         label: 'Services',
  //       },
  //     ],
  //   },
  // ],
  [
    {
      name: 'fieldOfActivity',
      placeholder: "Domaine d'activité...",
      label: "Domaine d'activité",
      type: 'select',
      id: 'field-of-activity',
      required: true,
    },
  ],
];
